<script>
    let BASE_URL = 'http://101.37.174.227:8088'
    let MP_CDN_URL='https://test.vistastory.com/api/mini_program/'
    let ENV={}
    if (process.env.NODE_ENV === 'production') {
        BASE_URL ='http://vistastory.com'
      MP_CDN_URL='https://www.vistastory.com/api/mini_program/'
    } else if (process.env.NODE_ENV === 'development') {
        BASE_URL = 'http://192.168.1.175:8080'
        // BASE_URL = 'http://test.vistastory.com'
      ENV.VITE_API_PREFIX=BASE_URL+'/formui'
//        BASE_URL ='http://vistastory.com'
//        BASE_URL = 'http://test.ifenghui.com:8088'
    } else if (process.env.NODE_ENV === 'beta') {
        BASE_URL = 'http://storybook.ifenghui.com/beta'
    } else if (process.env.NODE_ENV === 'testing') {
      BASE_URL = 'http://test.vistastory.com'
    }
    window.BASE_URL = BASE_URL
    window.MP_CDN_URL = MP_CDN_URL
    window.ENV=ENV
    // window.UEDITOR_CONFIG_APIURL=BASE_URL
    export default{
        BASE_URL
    }
</script>



// WEBPACK FOOTER //
// src/Global.vue